<mat-expansion-panel (opened)="panelOpen = true" (closed)="panelOpen = false" hideToggle>
    <mat-expansion-panel-header class="py-5 px-4">
        <mat-panel-title class="d-flex">
            <div class="container d-flex flex-column">
                <h2 class="header-title" [class.complete]="form.valid && !form.pristine" [class.error]="!form.valid && !form.pristine">Address</h2>
            </div>
            <div>
                <mat-icon *ngIf="form.pristine && !panelOpen" class="header-toggle">
                    expand_more
                </mat-icon>
                <mat-icon *ngIf="form.pristine && panelOpen" class="header-toggle">
                    expand_less
                </mat-icon>
                <mat-icon *ngIf="!form.pristine && form.valid" class="header-toggle complete">
                    checked
                </mat-icon>
                <mat-icon *ngIf="!form.pristine && !form.valid" class="header-toggle error">
                    close
                </mat-icon>
           </div>
        </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="panel-body-container mx-2">
        <form [formGroup]="form">
            <div class="row">
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline" hideRequiredMarker>
                        <mat-label>Address Line 1<span class="required-input">*</span></mat-label>
                        <input type="text" matInput placeholder="Address 1" formControlName="address_line_1">
                        <mat-error *ngIf="form.get('address_line_1')?.invalid">Required</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>Address Line 2</mat-label>
                        <input type="text" matInput placeholder="Address 2" formControlName="address_line_2">
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline" hideRequiredMarker>
                        <mat-label>City<span class="required-input">*</span></mat-label>
                        <input type="text" matInput placeholder="City" formControlName="city">
                        <mat-error *ngIf="form.get('city')?.invalid">Required</mat-error>
                    </mat-form-field>
                </div>
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline" hideRequiredMarker *ngIf="form.get('country_id')?.value == 1; else euState">
                        <mat-label>State/Province<span class="required-input">*</span></mat-label>
                        <mat-select formControlName="state">
                            <mat-option *ngFor="let state of states" [value]="state.value">{{ state.label }}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="form.get('state')?.invalid">Required</mat-error>
                    </mat-form-field>
                    <ng-template #euState>
                        <mat-form-field appearance="outline" hideRequiredMarker>
                            <mat-label>State/Province</mat-label>
                            <input type="text" matInput placeholder="State/Province" formControlName="state">
                            <mat-error *ngIf="form.get('state')?.invalid">Required</mat-error>
                        </mat-form-field>
                    </ng-template>
                </div>
            </div>
            <div class="row">
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline" hideRequiredMarker>
                        <mat-label>Postal Code<span class="required-input">*</span></mat-label>
                        <input type="text" matInput placeholder="Postal Code" formControlName="postal_code">
                        <mat-error *ngIf="form.get('postal_code')?.invalid">Required</mat-error>
                    </mat-form-field>
                </div>
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline" hideRequiredMarker>
                        <mat-label>Country<span class="required-input">*</span></mat-label>
                        <mat-select formControlName="country_id">
                            <mat-option *ngFor="let country of countries" [value]="country.id">{{ country.display_text }}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="!form.get('country_id')?.invalid">Required</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <mat-action-row class="mt-4 d-flex flex-row align-content-center">
                <div class="d-flex align-items-center text-muted" style="margin-right: auto;">
                    <span class="required-input">*</span>&nbsp;- Required fields before submitting property
                </div>
            </mat-action-row>
        </form>
    </div>
</mat-expansion-panel>